'use client';

import { c as _c } from "react/compiler-runtime";
import { unwrapFromResult } from '@shared/utils/helpers/resultWrapper';
import Logo from '@shared/utils/icons/Logo';
import { useInfiniteQuery } from '@tanstack/react-query';
import { ArrowUpDown, TrendingDown, TrendingUp } from 'lucide-react';
import Link from 'next/link';
import { useState } from 'react';
import { InView } from 'react-intersection-observer';
import { client } from '../../utils/trpc';
import Avatar from '../common/Avatar';
import Button from '../common/Button';
import Error from '../common/Error';
import Modal, { ModalContent, ModalHeader } from '../HOC/Modal';
type SortOrder = 'highest' | 'lowest';
type Props = {
  username?: string;
  factiiiId?: number;
  closeHandler: () => void;
};
export const FactiiiCountModal = t0 => {
  const $ = _c(60);
  const {
    username,
    factiiiId,
    closeHandler
  } = t0;
  const [sortOrder, setSortOrder] = useState("highest");
  const t1 = username ?? null;
  const t2 = factiiiId ?? null;
  let t3;
  if ($[0] !== sortOrder || $[1] !== t1 || $[2] !== t2) {
    t3 = ["FactiiisCount", sortOrder, t1, t2];
    $[0] = sortOrder;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const queryKey = t3;
  const isUserContext = Boolean(username);
  let t4;
  if ($[4] !== factiiiId || $[5] !== sortOrder || $[6] !== username) {
    t4 = async t5 => {
      const {
        pageParam
      } = t5;
      if (username) {
        return await unwrapFromResult(client.users.factiiisCount.query({
          cursor: pageParam,
          sortOrder,
          username
        }));
      } else {
        return await unwrapFromResult(client.factiiis.getRelated.query({
          factiiiId: factiiiId || 0,
          cursor: pageParam
        }));
      }
    };
    $[4] = factiiiId;
    $[5] = sortOrder;
    $[6] = username;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = Boolean(username) || typeof factiiiId === "number";
  let t6;
  if ($[8] !== queryKey || $[9] !== t4 || $[10] !== t5) {
    t6 = {
      queryKey,
      queryFn: t4,
      select: _temp2,
      initialPageParam: undefined as number | undefined,
      getNextPageParam: _temp3,
      enabled: t5
    };
    $[8] = queryKey;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const {
    data: data_0,
    error,
    isFetching,
    hasNextPage,
    fetchNextPage
  } = useInfiniteQuery(t6);
  let t7;
  if ($[12] !== sortOrder) {
    t7 = () => {
      setSortOrder(sortOrder === "highest" ? "lowest" : "highest");
    };
    $[12] = sortOrder;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const toggleSort = t7;
  const t8 = isUserContext ? `${username}'s Factiiis` : "Related Factiiis";
  let t9;
  if ($[14] !== t8) {
    t9 = <h1>{t8}</h1>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== closeHandler || $[17] !== t9) {
    t10 = <ModalHeader closeHandler={closeHandler}>{t9}</ModalHeader>;
    $[16] = closeHandler;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== sortOrder) {
    t11 = sortOrder === "highest" ? <TrendingDown className="size-4" /> : <TrendingUp className="size-4" />;
    $[19] = sortOrder;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const t12 = sortOrder === "highest" ? "Most Used" : "Least Used";
  let t13;
  if ($[21] !== t12) {
    t13 = <span className="text-sm">{t12}</span>;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <ArrowUpDown className="size-3" />;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t11 || $[25] !== t13) {
    t15 = <div className="flex items-center space-x-2">{t11}{t13}{t14}</div>;
    $[24] = t11;
    $[25] = t13;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t15 || $[28] !== toggleSort) {
    t16 = <div className="mb-4 flex justify-end"><Button titleElement={t15} variant="SECONDARY" classNames="text-xs px-3 py-1.5" onClick={toggleSort} /></div>;
    $[27] = t15;
    $[28] = toggleSort;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== data_0 || $[31] !== isUserContext) {
    t17 = data_0?.map((factiii, index) => {
      const count = factiii.count;
      return <Link key={factiii.id} href={`/fids/${factiii.id}`} className="group block rounded-lg border border-ds-border-standard bg-background-secondary p-3 transition-colors hover:bg-background-light"><div className="flex items-center justify-between"><div className="flex items-center space-x-3"><span className="w-6 text-sm text-textSecondary">{index + 1}</span><Avatar factiiiAvatarKey={factiii.avatarKey ?? null} factiiiId={factiii.id} size={36} /><div><h4 className="font-emphasis text-textPrimary group-hover:text-primary">{factiii.name}</h4><p className="text-sm text-textSecondary/60">{factiii.description || `factiiis/${factiii.id}`}</p></div></div><div className="text-right"><div className="text-lg font-semibold text-textPrimary">{count}</div><div className="text-xs text-textSecondary/60">{isUserContext ? "uses" : "co-occurrences"}</div></div></div></Link>;
    });
    $[30] = data_0;
    $[31] = isUserContext;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t17) {
    t18 = <div className="space-y-2">{t17}</div>;
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== data_0?.length || $[36] !== error || $[37] !== isFetching || $[38] !== isUserContext || $[39] !== username) {
    t19 = !isFetching && !error && data_0?.length === 0 && <div className="flex flex-col items-center justify-center py-12 text-center"><Logo height={64} rounded={true} /><h3 className="mb-2 text-lg font-semibold text-textPrimary">{isUserContext ? "No Factiiis Yet" : "No Related Factiiis"}</h3><p className="text-sm text-textSecondary/70">{isUserContext ? `${username} hasn't used any factiiis yet.` : "This factiii doesn't appear together with others on posts yet."}</p></div>;
    $[35] = data_0?.length;
    $[36] = error;
    $[37] = isFetching;
    $[38] = isUserContext;
    $[39] = username;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== fetchNextPage || $[42] !== hasNextPage || $[43] !== isFetching) {
    t20 = hasNextPage && <InView onChange={isVisible => isVisible && !isFetching ? fetchNextPage() : undefined} className="mt-4 flex justify-center"><div className="flex items-center justify-center py-4"><div className="size-6 animate-spin rounded-full border-2 border-primary border-t-transparent" /></div></InView>;
    $[41] = fetchNextPage;
    $[42] = hasNextPage;
    $[43] = isFetching;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== error || $[46] !== isFetching || $[47] !== isUserContext || $[48] !== username) {
    t21 = Boolean(error) && <Error error={error} loading={isFetching} message={isUserContext ? `Failed to load ${username}'s factiiis. Please try again.` : "Failed to load related factiiis. Please try again."} />;
    $[45] = error;
    $[46] = isFetching;
    $[47] = isUserContext;
    $[48] = username;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] !== t16 || $[51] !== t18 || $[52] !== t19 || $[53] !== t20 || $[54] !== t21) {
    t22 = <ModalContent><div className="flex max-h-[700px] flex-col">{t16}{t18}{t19}{t20}{t21}</div></ModalContent>;
    $[50] = t16;
    $[51] = t18;
    $[52] = t19;
    $[53] = t20;
    $[54] = t21;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  let t23;
  if ($[56] !== closeHandler || $[57] !== t10 || $[58] !== t22) {
    t23 = <Modal closeHandler={closeHandler}>{t10}{t22}</Modal>;
    $[56] = closeHandler;
    $[57] = t10;
    $[58] = t22;
    $[59] = t23;
  } else {
    t23 = $[59];
  }
  return t23;
};
function _temp(page) {
  return page.factiiisCount || [];
}
function _temp2(data) {
  return data?.pages.flatMap(_temp);
}
function _temp3(lastPage) {
  const factiiisCount = lastPage.factiiisCount ?? [];
  if (factiiisCount.length < 10) {
    return;
  }
  return factiiisCount[factiiisCount.length - 1]?.id;
}